module.exports = __webpack_public_path__ + "static/img/echart5.64ad38d0.png";